import React,{useEffect,useState} from 'react'
import styled from '@emotion/styled'
import {getProfessional} from "../../network";
import LoadingComponent from '../shared/LoadingComponent';

const Container = styled.div`
    width: auto;
    display: flex;
    flex-direction: column;
    height: 30vh;
    justify-content: space-between;
  
    .search{
        position: absolute;
        top:14.2rem;
        left:23.5rem;
    }
    @media only screen and (max-width: 500px) {
        display: flex;
        flex-direction: column;
    }

`;
const Header = styled.h1`
    width:20rem;
    /* align-self: end; */
    font-weight: 500;
    font-size: var(--font-32);
    line-height: var(--space-32);
    color:var(--color-gray-800);

 @media (max-width: 500px){
    font-size: var(--font-24);
    padding-bottom: 2rem;
 }

`;
const Text = styled.p`
    width:32rem;
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-16);
    line-height: var(--space-24);
    color:var(--color-gray-800);
  
    @media only screen and (max-width: 500px) {
        width: auto;
        padding-bottom: 2rem;
    }
   
`;
const Search = styled.input`
    width: 21.11rem;
    padding: var(--space-10);
    /* align-self: end; */
    font-family: Inter,sans-serif;
    font-size: var(--font-16);
    margin-bottom: 2rem;
    background: var(--color-white);
    border: 1px solid #8D9AA5;
    box-sizing: border-box;
    border-radius: 1.25rem;
    text-indent: 1rem;

    background-image: url(/icons/search-icon.svg);
    background-repeat: no-repeat;
    background-position-x: 19rem;
    background-position-y: center;
    background-origin: content-box;
    

    @media (max-width: 500px){
        margin-bottom: 2rem;
    }
    
`;
const SelectContainer = styled.div`
    display:grid;
    grid-auto-flow:column;
    margin-bottom: 2rem;
    align-items: end;
    @media (max-width: 768px){
       width:40rem;
       grid-gap:2rem;
    }
    
    @media only screen and (max-width: 500px) {
        width:20rem;
        margin-left: 2rem;
    }
  
`;
const ProfessionalContainer = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    width:auto;

    p{
        font-family: Inter, sans-serif;
        line-height: var(--space-24);
    }

    :nth-of-type(even){
        flex-direction:row-reverse;
        padding:var(--space-10);
        width: auto;
        justify-content: space-between;
    }
    @media only screen and (max-width: 500px) {

        width: auto;
        position:relative;
        height: 16rem;
        justify-content: space-between;
        margin-bottom: 3rem;

        :nth-of-type(even){
            flex-direction:row;
            padding:var(--sapce-10);
            justify-content: end;
           
        }
    }

   
`;
const FilterContainer = styled.span`
    display:grid;
    grid-auto-flow:column;
    grid-gap:1rem;
    width:12.65rem;
    span{
        white-space:nowrap;
    }
    .results{
        display: none;
    }
    @media only screen and (max-width: 500px) {
        width: auto;
        position: relative;
        justify-content: space-between;
        align-content: flex-end;
        margin-bottom: 1rem;
        span{
            display:none;
        }
        .results{
            display: flex;
            font-size: var(--font-16);
            color: var(--color-gray-400);
            align-self: center;
        }
    }
    @media only screen and (max-width: 400px) {
 
    }
`;
const Divider = styled.div`
    width: auto;
    height: 0rem;
    margin-bottom: 2rem;
    border: 1px solid #D3D9DE;
    @media (max-width: 768px){
      width:40rem;
    }
    @media only screen and (max-width: 500px) {
        position: relative;
        width: auto;
        margin-bottom: 2rem;
    }

`;
const Location = styled.select`
    height: 2.25rem;
    padding: var(--space-8) var(--space-32);
    background: var(--color-white);
    border: 1px solid var(--color-gray-400);
    box-sizing: border-box;
    border-radius: 2.25rem;

    -webkit-appearance:none;
    background-image: url(/icons/chevron.svg);
    background-repeat: no-repeat;
    background-position-x: 8rem;
    background-position-y:center;
    background-origin: content-box;


    @media only screen and (max-width: 425px) {
        display:none;
    }
`;
const Filter = styled.div`
    cursor:pointer;
    display:grid;
    grid-auto-flow:column;
    padding: var(--space-8) var(--space-12);
    grid-gap:1.2rem;
    justify-content:center;
    /* width: 4.88rem; */
    /* height: var(--space-12); */
    color:var(--color-gray-800);
    background: var(--color-white);
    border: 1px solid var(--color-gray-400);
    border-radius: 2.25rem;
    

    @media (max-width: 500px){
        align-self: center;
    }
`;
const Title = styled.p`
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-14);
    line-height: var(--space-24);
    margin-top:5rem;
    color: var(--color-gray-700);

    @media only screen and (max-width: 500px) {
        width: auto;
        margin-top: 1.5rem;
    }
`;
const Doctor = styled.h1`
    font-style: normal;
    font-weight: 500;
    font-size: var(--font-24);
    line-height: var(--space-24);

    color: var(--company-dark);

    @media only screen and (max-width: 500px) {
        width: auto;
        white-space:nowrap;
        font-size: var(--font-18);
    }
`;
const Badge = styled.div`
    display: flex;
    flex-direction: row;
    padding: var(--space-8);
    
    color:var(--color-white);
    background: var(--color-orange-500);
    border-radius: 2.25rem;

    img{
        padding-left: var(--space-16);
        padding-right: var(--space-8);
    }

    @media (max-width: 500px){
        border-radius: var(--space-8);

    }
`;
const ImageContainer = styled.div`
    display:flex;
   
  
`;
const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 20rem;
    justify-content: space-between;

    /* p{
        width:36rem;
    } */
    @media only screen and (max-width: 768px) {
        p{
            width:40vw;
        }
    }
    @media only screen and (max-width: 500px) {
        width: auto;
       
        p{
            width: auto;
           
        }
    }
`;
const MiniDivider = styled.div`
    width: 18.75rem;
    height: 1px;
    background-color: var(--color-gray-300);
`;
const Address =styled.div`
    display: flex;
    flex-direction: row;
    width:12rem;
    color:var(--color-gray-900);
    background: var(--color-white);
    border-radius: 2.25rem; 
    img{
        padding-right: var(--space-8);
    }
    
`;
const BorderContainer = styled.div`
    overflow:hidden;
    border-radius: 2.25rem 3.56rem 0px 5.125rem;
    height:23rem;
    width:17.25rem;
    @media only screen and (max-width: 500px) {
        position:relative;
        right:22rem;
        top:4rem;
        img{
            object-fit:contain;
            width:100%;
            height:100%;
        }
        width:5rem;
        height:5rem;
        border-radius:1.25rem;
    }
    @media only screen and (max-width: 400px) {
        right: 20rem;
    }
`;
const PaginationContainer = styled.div`
    
    display: flex;
    flex-direction: row;
    padding: var(--space-8) var(--space-12);
    width: 9.125rem;
    height: 3.125rem;
    justify-content:center;
    background: #FFFFFF;
    border: 1px solid #B3BDC6;
    box-sizing: border-box;
    border-radius: 2.75rem;
    transition: background-color 0.3s ease-in;

    :hover{
        background-color: var(--color-gray-100);
    }
    @media only screen and (max-width: 500px) {
      
        top: 5rem;
    }
`;
const Pagination = styled.div`
    display: flex;
    flex-direction: row;
    padding: var(--space-6) var(--space-12);
    white-space:nowrap;
    justify-self:center;
    width: 4.125rem;
    height: var(--space-32);


    background: #FFFFFF;
    

    border: 1px solid #B3BDC6;
    box-sizing: border-box;
    border-radius: 0.375rem;
`;
const ClearFilterContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: var(--space-10) var(--space-16);
    justify-content:space-between;
    width: 11.1rem;
    height: var(--space-32);
    cursor: pointer;

    background: #EDF0F2;
    /* default/gray/400 */

    border: 1px solid #B3BDC6;
    box-sizing: border-box;
    border-radius: 36px;
    span{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 1rem;
        line-height: 2rem;
        /* identical to box height, or 100% */

        display: flex;
        align-items: center;

        /* default/gray/700 */

        color: #525B64;
    }


    @media only screen and (max-width: 425px) {
        display: none;
     
    }
`;

const ProfessionalImage = styled.img`
    width: 5rem;
    height: 5rem;
    object-fit: cover;
    object-position: top;
    border-radius: var(--space-8);
    align-self: flex-end;
`;

const Professional = () => {
    const [professional, setProfessional] = useState([
        {
            profession: 'Dietician',
            title: 'Dr.',
            first_name: 'Kamilla',
            last_name: 'Brown',
            email: 'kamila.brown.md@gmail.com',
            work_location: '23 Seymour Avenue'
        },
        {
            profession: 'Dietician',
            title: 'Dr.',
            first_name: 'Kamilla',
            last_name: 'Brown',
            email: 'kamila.brown.md@gmail.com',
            work_location: '30 Seymour Avenue'
        },
        {
            profession: 'Dietician',
            title: 'Dr.',
            first_name: 'Kamilla',
            last_name: 'Brown',
            email: 'kamila.brown.md@gmail.com',
            work_location: '23 Seymour Avenue'
        },
        {
            profession: 'Dietician',
            title: 'Dr.',
            first_name: 'Kamilla',
            last_name: 'Brown',
            email: 'kamila.brown.md@gmail.com',
            work_location: '23 Seymour Avenue'
        },
]); 
    const [num,setNum] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [resultsCount, setResultsCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(2);
    const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmaXJzdF9uYW1lIjoiSG93YXJkIiwibGFzdF9uYW1lIjoiRWR3YXJkcyIsImVtYWlsIjoiaG93YXJkLmVkd2FyZHNAc21zamEubmV0IiwidXNlcl9pZCI6IjVlNzE4MjFhZDc0NzM4NWRmOTkyMTZmMCIsInJvbGVfaWQiOiI1ZTczYzA4NzYxMTUyNDMyZjM4OGIwODkiLCJpYXQiOjE1OTI5NTMxMTAsImV4cCI6MTU5NTU0NTExMH0.iZVzm6NkayyuOMC__2oJwSEjkgXYG_ypbGqIBEBq5EE"
    const [loading,setLoading] = useState(true);
    const [canvasWidth, setCanvasWidth] = useState(0);


    useEffect(() => {
        handleResize();
    });
    const handleResize = () => {
        setCanvasWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
      
    };

    const increment = () =>{
        if(currentPage <= Math.ceil(totalCount/pageLimit) -1)
            setCurrentPage(currentPage + 1);
    }
    const decrement = () =>{
        if(currentPage > 1)
            setCurrentPage(currentPage - 1)
    }

    useEffect(() => {
        searchProfessional(searchText,currentPage);
    }, [searchText,currentPage]);

    const searchProfessional = (search,currentPage) => {
        getProfessional(token,search,currentPage, pageLimit)
            .then(result => {
                
                setProfessional([...result.data]);
                setResultsCount(result.results);
                setTotalCount(result.total);
               
            })
            .catch(error => console.error(error))
            .finally(() => setLoading(false));
    }
    const filterChange = (e) =>{
        let num = 0;
        setSearchText(e.target.value.trim());
        num += 1;
        setNum(num);
    }


    const onSearchTextChange = e => setSearchText(e.target.value.trim());

    return (
        <>
        {loading ?
            <div style={{marginLeft:"2rem"}}>
                <LoadingComponent/>
           </div>
        :    
    
        <Container>
            <Header style={{marginBottom: '2rem'}}>Medical Professionals</Header>
            <Text style={{marginBottom: '2rem'}}>Unsure of what your projected procedure entails?
                Still nervous about going through with it?
                We’re here to keep you informed, 
                without sugar-coating the process. 
                Find your procedure below and we’ll walk you through.</Text>
                <Search type="search" placeholder="Find a professional here..." onChange={onSearchTextChange}/>
                {/* <img class="search" src="/icons/search-icon.svg"/> */}
                {canvasWidth > 500 ? 
                <SelectContainer>
                    <FilterContainer>
                        <span style={{lineHeight:"36px"}}>Sort By</span>
                        <Location onChange={(e)=>filterChange(e)}>
                        <option value="">Location</option>
                        {professional.map((value,index) =>  
                        <option key={index} value={value.work_location}>{value.work_location}</option>
                        )}
                        
                        </Location>
                    </FilterContainer>
                    <FilterContainer>
                        <span className="results">{1+" - "+resultsCount+" of "+totalCount+" results"}</span>
                        <ClearFilterContainer onClick={()=>{setSearchText('');setNum(0)}}><span>{`Clear Filters (${num})`}</span><img src="/icons/red_close.svg"/></ClearFilterContainer>
                        <Filter>Filters<img src="/icons/filter.svg"/></Filter>
                    </FilterContainer>
                </SelectContainer>
                :
                <FilterContainer>
                    <span className="results">{1+" - "+resultsCount+" of "+totalCount+" results"}</span>
                    <ClearFilterContainer onClick={()=>{setSearchText('');setNum(0)}}><span>{`Clear Filters (${num})`}</span><img src="/icons/red_close.svg"/></ClearFilterContainer>
                    <Filter>Filters<img src="/icons/filter.svg"/></Filter>
                </FilterContainer>
            }
            <Divider/>
           
         {professional.map((value,index) => 
            <>
             {canvasWidth < 500 ? 
            <ProfessionalContainer key={index}>
                    <InfoContainer>
                        <div style={{display:"flex",flexDirection:"row"}}>
                           
                                <ProfessionalImage src="/irad-team/k-brown.svg"/>
                          
                            <div style={{paddingLeft:"1rem"}}>
                                <Title>{value.profession}</Title>
                                <Doctor>{value.title} {value.first_name} {value.last_name}</Doctor>
                            </div>
                        </div>
                        <p>{value.summary}</p>
                        {value.work_location ? <Address><img src="/img/svg/map.svg"/>{value.work_location}</Address>:""}
                        {value.email ? <Badge><img src="/img/svg/white-email.svg"/>{value.email}</Badge>:""}
                        <MiniDivider/>
                    </InfoContainer>

            </ProfessionalContainer>
            :
            <ProfessionalContainer key={index}>
            <InfoContainer>
        
                <Title>{value.profession}</Title>
                <Doctor>{value.title} {value.first_name} {value.last_name}</Doctor>
                <p>{value.summary}</p>
                {value.work_location ? <Address><img src="/img/svg/map.svg"/>{value.work_location}</Address>:""}
                {value.email ? <Badge><img src="/img/svg/white-email.svg"/>{value.email}</Badge>:""}
                <MiniDivider/>
            </InfoContainer>
            <ImageContainer>
                <BorderContainer>
                    <img src="/irad-team/k-brown.svg"/>
                </BorderContainer>
            </ImageContainer>
    </ProfessionalContainer>
            }
           </>
          
            )}
            {totalCount ? 
            <PaginationContainer>
                <img onClick={decrement}style={{marginRight:"10px",cursor:"pointer"}} src="/icons/chevron_left.svg"/>
                <Pagination>
                    <span>{currentPage+" of "+Math.ceil(totalCount/pageLimit)}</span>
                </Pagination>
                <img onClick={increment}style={{marginLeft:"10px",cursor:"pointer"}}src="/icons/chevron_right.svg"/>
            </PaginationContainer>
            :""}
        </Container>
    }
    </>
    )
}

export default Professional
